<template>
  <v-container>
    <module-bar title="REPORTE DE HERRAMIENTAS" icon="mdi-file-chart" />

    <v-row v-if="loadingData">
      <v-col class="d-flex justify-center">
        <v-progress-circular indeterminate color="primary" width="1" size="60" />
      </v-col>
    </v-row>

    <v-row v-if="loadedData">
      <v-col>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar herramienta" single-line hide-details
          style="max-width: 400px" class="mb-5"></v-text-field>

        <v-card outlined>
          <v-data-table :search="search" :headers="headers" :items="items" :items-per-page="10" :mobile-breakpoint="800"
            @click:row="openDialogTool">
            <template v-slot:[`item.assigned`]="{ item }">
              <v-chip small :text-color="item.assigned != 'No asignado' ? 'white' : 'black'"
                :color="item.assigned != 'No asignado' ? 'green' : 'default'">{{ item.assigned }}
              </v-chip>
            </template>

            <template v-slot:[`item.employee.names`]="{ item }">
              <v-avatar size="38" v-if="item.employee">
                <v-img :src="item.employee.photo_url" />
              </v-avatar>
              {{ item.employee ? item.employee.names : '' }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogTool" persistent width="800">
      <v-card>
        <v-card-text>
          <tool-form schema="edit" :tool="tool" :click="click" title="EDITAR HERRAMIENTA"
            @closeDialogTool="closeDialogTool" @desvinculeEmployee="desvinculeEmployee"
            @vinculeEmployee="vinculeEmployee" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ModuleBar from "../../components/General/ModuleBar.vue";
import ToolForm from "../../components/Forms/ToolForm.vue";

export default {
  components: {
    ModuleBar,
    ToolForm,
  },

  beforeMount() {
    this.loadingData = true;
    this.loadedData = false;
    setTimeout(() => {
      this.$store.dispatch("findToolsAction").then((res) => {
        this.items = res;
        this.loadingData = false;
        this.loadedData = true;
      });
    }, 500);
  },

  data() {
    return {
      loadingData: true,
      loadedData: false,
      dialogTool: false,
      tool: null,
      search: "",
      click: 0,
      headers: [
        {
          text: "Nombre",
          value: "name",
          width: "20%",
        },
        {
          text: "Asignado",
          value: "assigned",
          width: "20%",
        },

        {
          text: "Provincia",
          value: "location.name",
          width: "20%",
        },

        {
          text: "Distrito",
          value: "district",
          width: "20%",
        },
        {
          text: "Descripcion",
          aling: "left",
          value: "description",
          width: "40%",
        },
      ],
      items: [],
    };
  },



  methods: {
    openDialogTool(value) {
      this.tool = value;
      this.dialogTool = true;
      this.click++;
    },

    closeDialogTool(data) {
      this.dialogTool = false;
      if (data) {
        let index = this.items.findIndex((v) => v.id == data.id);
        if (data.is_delete) {
          this.items.splice(index, 1);
          return;
        }
        this.items.splice(index, 1, data);
      }
    },

    desvinculeEmployee({ toolId }) {
      let index = this.items.findIndex((v) => v.id == toolId);
      if (index > -1) {
        this.items[index].employee_id = 0;
      }
    },

    vinculeEmployee(data) {
      let index = this.items.findIndex(
        (v) => v.id == parseInt(data.tool_id)
      );

      if (index > -1) {
        this.items[index].employee = data.employee;
        this.items[index].employee_id = data.employee.id;
      }
    },
  },
};
</script>
